import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import ButtonComponent from '../../atoms/button'
import { SpinnerWhite } from '../../atoms/icons/special'

import {
  alertIconVariantOptions,
  alertOrientationVariantOptions,
  alertAlignVariantOptions
} from './constants'

import {
  AlertOverlay,
  AlertBase,
  AlertContentContainer,
  ContentHeaderContainer,
  HeaderContainerTitle,
  ContentDescriptionContainer,
  DesriptionContainerText,
  AlertActionsButtonsContainer,
  AlertLoaderContainer,
  ChildrenContainer
} from './styled-components'

const AlertComponent = forwardRef(
  (
    {
      variant,
      width,
      height,
      title,
      description,
      actionButtons = [],
      buttonOrientation = alertOrientationVariantOptions.STACKED,
      buttonAlignment = 'end',
      isSlowLoading,
      isOpen = true,
      activeOverlay = false,
      children,
      ...props
    },
    ref
  ) => {
    if (!isOpen) {
      return null
    }

    return (
      <AlertOverlay activeOverlay={activeOverlay} {...props}>
        <AlertBase
          ref={ref}
          isOverlay={activeOverlay}
          width={width}
          height={height}
        >
          {isSlowLoading && (
            <AlertLoaderContainer>
              <SpinnerWhite size="icon-xl" />
            </AlertLoaderContainer>
          )}

          <AlertContentContainer>
            <ContentHeaderContainer>
              {title && (
                <>
                  <HeaderContainerTitle>{title}</HeaderContainerTitle>
                  {alertIconVariantOptions[variant]}
                </>
              )}
            </ContentHeaderContainer>
            <ContentDescriptionContainer>
              {description && (
                <DesriptionContainerText>{description}</DesriptionContainerText>
              )}
            </ContentDescriptionContainer>
            {children && <ChildrenContainer>{children}</ChildrenContainer>}
          </AlertContentContainer>
          <AlertActionsButtonsContainer
            direction={buttonOrientation}
            align={buttonAlignment}
          >
            {actionButtons.map((propsItem, index) => (
              <ButtonComponent key={index} {...propsItem} />
            ))}
          </AlertActionsButtonsContainer>
        </AlertBase>
      </AlertOverlay>
    )
  }
)

AlertComponent.propTypes = {
  variant: PropTypes.string,
  size: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  buttonOrientation: PropTypes.oneOf(
    Object.values(alertOrientationVariantOptions)
  ),
  buttonAlignment: PropTypes.oneOf(Object.values(alertAlignVariantOptions)),
  actionButtons: PropTypes.arrayOf(PropTypes.object),
  isSlowLoading: PropTypes.bool,
  isOpen: PropTypes.bool,
  activeOverlay: PropTypes.bool,
  children: PropTypes.node
}

AlertComponent.displayName = 'AlertComponent'

export default AlertComponent
